module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8517/img/favicon-dark.png"